import type { Opportunity } from "@repo/api";

export const setActiveProject = (
  project?: Opportunity | null,
  shouldClear?: boolean
) => {
  if (window.salja?.salesLead?.setProjectData) {
    if (shouldClear) {
      window.salja.salesLead.setProjectData(null, true);
    } else if (project) {
      window.salja.salesLead.setProjectData(
        {
          projectId: project.id.toString(),
          title: project.title,
        },
        false
      );
    } else {
      window.salja.salesLead.setProjectData(null, false);
    }
  }
};
